// 需要登陆的，都写到这里，否则就是不需要登陆的接口
const methodsToken = [
	'user.info',
    'user.editinfo',
    'user.changeavatar',
    'user.logout',
    'user.addgoodsbrowsing',
    'user.delgoodsbrowsing',
    'user.goodsbrowsing',
    'user.goodscollection',
    'user.goodscollectionlist',
    'user.saveusership',
    'user.vuesaveusership',
    'user.getshipdetail',
    'user.setdefship',
    'user.editship',
    'user.removeship',
    'user.getusership',
    'user.pay',
    'user.orderevaluate',
    'user.getuserdefaultship',
    'user.issign',
    'user.sign',
    'user.mypoint',
    'user.userpointlog',
    'user.getbankcardlist',
    'user.getdefaultbankcard',
    'user.addbankcard',
    'user.removebankcard',
    'user.setdefaultbankcard',
    'user.getbankcardinfo',
    'user.editpwd',
    'user.forgotpwd',
    'user.recommend',
    'user.balancelist',
    'user.sharecode',
    'user.cash',
    'user.cashlist',
    'user.myinvoicelist',
    'coupon.getcoupon',
    'coupon.usercoupon',
    'cart.add',
    'cart.del',
    'cart.getlist',
    'cart.setnums',
    'cart.getnumber',
	'cart.getlistselectall',
    'order.cancel',
    'order.del',
    'order.details',
    'order.confirm',
    'order.getlist',
    'order.create',
    'order.getship',
    'order.getorderlist',
    'order.getorderstatusnum',
    'order.aftersaleslist',
    'order.aftersalesinfo',
    'order.aftersalesstatus',
    'order.addaftersales',
    'order.sendreship',
    'order.iscomment',
    'payments.getinfo',
    'user.getuserpoint',
    'coupon.getcouponkey',
    'store.isclerk',
    'store.storeladinglist',
    'store.ladinginfo',
    'store.lading',
    'store.ladingdel',
    'club.clubcollection',
    'club.collectionlist',
    "course.courseevaluate",
    "course.pay",
    "course.checkcourse",
    "news.courseevaluate",
    "course.getorderlist",
    "channelbusiness.getstafflist",
    "channelbusiness.getinfo",
    "channelbusiness.getorder",
    "user.addalipay",
    "user.getalipaylist",
    "club.join",
    "club.getclub",
    "channelbusiness.savestaff",
    "channelbusiness.addstaff",
    "channelbusiness.getstaffinfo",
    "channelbusiness.delstaff",
    "channelbusiness.stafforder",
    "channelbusiness.apply",
    "channelbusiness.getinfo",
    "channelbusiness.bussinesswithdrawallist",
    "channelbusiness.examine",
    "channelbusiness.withdrawallist",
    "channelbusiness.cash",
    "images.upload",
    "institution.describeedit",
    "game.pay",
    "game.tagselectinstitutionuser",
    "game.getinstitutionorder",
    "payments.checkpay",
    "examination.planlist",
    "examination.planinfo",
    "examination.orderinfo",
    "examination.examinationopiclist",
    "examination.pay",
    "examination.achievementlist",
    "examination.typelist",
    "examination.practicetopiclist",
    "examination.questionsubmit",
    "examination.questioncollect",
    "examination.collectlist",
    "examination.collecttopiclist",
    'examination.certificate',
    'api.getmessagemenu.pushMessage',
    'api.getmessgaelist.pushMessage'
];
export default methodsToken;